import {NgModule} from '@angular/core';

import { BrowserGlazingBeadsService } from './glazing-beads.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GlazingBeadsService } from '../../glazing-beads.service';
import {SealColorsService} from './seal-colors.service';
import {SiliconeColorsService} from './silicone-colors.service';
import {SealColorsDefaultsService} from './seal-colors-defaults.service';
import {SiliconeColorsDefaultsService} from './silicone-colors-defaults.service';
import {WarmEdgesService} from './warm-edges.service';
import {FillingsService} from './fillings.service';
import { GlazingUnitsService } from './glazing-units.service';
import {BondedGlazingService} from './bonded-glazing.service';
import { GlazingSizesService } from './glazing-sizes.service';
import { FillingValidationService } from './filling-validation.service';

@NgModule({
    imports: [],
    exports: [],
    declarations: [],
    providers: [
        BrowserGlazingBeadsService,
        {provide: GlazingBeadsService, useExisting: BrowserGlazingBeadsService},
        SealColorsService,
        SealColorsDefaultsService,
        SiliconeColorsService,
        SiliconeColorsDefaultsService,
        WarmEdgesService,
        FillingsService,
        GlazingSizesService,
        GlazingUnitsService,
        BondedGlazingService,
        FillingValidationService
    ],
})
export class GlazingsModule {
    constructor() {}
}
